import { createApp, h } from 'vue';
import { vMaska } from 'maska/vue';
import PortalVue from 'portal-vue';
import SharedUrlPassword from './sharedUrlPassword.vue';

export default () => {
  setTimeout(() => {
    document.getElementById('preLoaderWrap').style.opacity = 0;
    document.getElementById('preLoaderWrap').pointerEvents = 'none';
    setTimeout(() => {
      document.getElementById('preLoaderWrap').remove();
    }, 600);
  }, 500);
  const app = createApp({
    components: {
      SharedUrlPassword,
    },
    render() {
      return h(SharedUrlPassword);
    },
  });

  app.use(PortalVue);
  app.directive('maska', vMaska);

  app.config.compilerOptions.whitespace = 'condense';
  app.mount('#shared-password-vue-container');
};
